import * as React from 'react';

// PACKAGES
import Moment from 'react-moment';

// TYPES
interface DisplayDateTimeTypes {
	children?: string | number | Date | moment.Moment;
	format?: string;
}

export const DisplayDateTime: React.FC<DisplayDateTimeTypes> = ({ children, format = 'DD/MM/YYYY hh:mm A' }) => {
	return (
		<Moment format={format} parse="YYYY-MM-DDTHH:mm:ss.SSSSSSSZ">
			{children}
		</Moment>
	);
};

export default DisplayDateTime;
